module.exports = __webpack_public_path__ + "img/company-icon.c9d8db19.svg";